<template>
  <ErrorPage :error="error" />
</template>

<script setup lang="ts">
import ErrorPage from '@/components/ErrorPage.vue'

defineProps({
  error: {
    type: Object,
    default: () => {
      return { statusCode: 500 }
    },
  },
})
</script>
